<template>
  <div class="nav__wrapper custom__cursor__pointer">
    <div class="nav__left">
      <div class="nav__logo">
        <IconLogoTestv class="LogoTestv"/>
        <span>铁丝俱乐部</span>
      </div>
    </div>
    <div class="nav__center">
      <transition-group name="btn__fade" tag="div" class="btns__wrapper">
        <SsButton2
          key="back"
          v-if="back"
          class="nav__btn btn__back"
          type="text"
          @click="onBack">
          <IconPrev class="nav__icon icon__back"/>
        </SsButton2>
        <SsButton2
          key="home"
          :class="[
            'nav__btn',
            'btn__home',
            { 'nav__btn--active': $route.name === 'Home' }
          ]"
          type="text"
          @click="onRoute({ name: 'Home'})">
          <IconHome class="nav__icon icon__home"/>
        </SsButton2>
        <SsButton2
          key="document"
          :class="[
            'nav__btn',
            'btn__document',
            { 'nav__btn--active': $route.name === 'Catalog' }
          ]"
          type="text"
          @click="onRoute({ name: 'Catalog'})">
          <IconDocument class="nav__icon icon__document"/>
        </SsButton2>
        <SsButton2
          key="member"
          :class="[
            'nav__btn',
            'btn__other',
            { 'nav__btn--active': $route.name === 'Member' }
          ]"
          type="text"
          @click="onRoute({ name: 'Member'})">
          <IconOther class="nav__icon icon__other"/>
        </SsButton2>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TestvNav',

  props: {
    back: Boolean
  },

  components: {
  },

  computed: {
    ...mapState(['history'])
  },

  methods: {
    onBack () {
      this.$store.commit('setAction', 'pop')
      // console.log('TestvNav: ', 'pop')
      if (history.length > 0) {
        this.$router.back(-1)
      } else {
        this.$router.replace({ name: 'Home' })
      }
    },
    onRoute (r) {
      this.$store.commit('setAction', 'push')
      this.$router.push(r)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.nav__wrapper {
  background: var(--dark-bwb-2);
  padding: 12px;
  position: relative;
  .nav__left {
    display: none;
    position: absolute;
    top: 0px;
    bottom: 0px;
    @media (min-width: $screen-md) {
      display: block;
    }
    .nav__logo {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: auto;
      color: var(--dark-bwb-6);
      font-size: 13px;
      .LogoTestv {
        width: 90px;
        height: 12px;
      }
    }
  }
  .btns__wrapper {
    display: flex;
    justify-content: center;
    column-gap: 64px;
  }
}
.nav__btn {
  padding: 4px;
  background: transparent;
  border: none;
  color: var(--dark-bwb-6);
  .nav__icon {
    width: 24px;
    height: 24px;
    vertical-align: middle;
    @media (min-width: $screen-md) {
      width: 28px;
      height: 28px;
    }
  }
  &.nav__btn--active {
    color: var(--yellow-testv);
  }
}

.btn__fade-move,
.btn__fade-enter-active,
.btn__fade-leave-active {
  transition: all 0.3s ease;
}

.btn__fade-enter-from,
.btn__fade-leave-to {
  opacity: 0;
  transform: scaleY(0.01) translate(-10px, 0);
}

.btn__fade-leave-active {
  position: absolute!important;
}
</style>
